import { TodoStatus } from "../../../utils/backend-types";
import { canTodoBeNotRelevant } from "./canTodoBeNotRelevant";

const MANTINE_OPTIONS = [
  { value: TodoStatus.Open, label: "Offen" },
  { value: TodoStatus.Done, label: "Erledigt" }
];

const MANTINE_OPTIONS_NOT_RELEVANT = [
  ...MANTINE_OPTIONS,
  { value: TodoStatus.NotRelevant, label: "Nicht relevant" }
];

export function getTodoStatusOptions(
  currentStatus: TodoStatus,
  todoLabel = "",
  isStaff = false
) {
  const isNotRelevant = currentStatus === TodoStatus.NotRelevant;
  const canBeNotRelevant = isStaff && canTodoBeNotRelevant(todoLabel);

  if (isNotRelevant || canBeNotRelevant) {
    return MANTINE_OPTIONS_NOT_RELEVANT;
  }

  return MANTINE_OPTIONS;
}
